import { b2PrismaticJointDef, b2Vec2 } from "./box2d-compat.js";
import { ScriptedLevelRuntime } from "./scripted-level-runtime.js";

export class LevelThreeRuntime extends ScriptedLevelRuntime {
  constructor(levelData, clock, runtimeState = null, options = {}) {
    super(levelData, clock, {
      deathY: 650,
      dynamicSprites: ["movePlatform1", "movePlatform2"],
      hazards: ["ship1", "ship2", "ship3"],
    }, runtimeState, options);
    this.beginFlag = runtimeState?.beginFlag ?? true;
  }

  configureLevel() {
    const ground = this.world.GetGroundBody();

    const joint1 = new b2PrismaticJointDef();
    joint1.Initialize(this.dynamicBodies.movePlatform1, ground, this.dynamicBodies.movePlatform1.GetWorldCenter(), new b2Vec2(0, 1));
    joint1.enableLimit = false;
    joint1.enableMotor = false;
    this.world.CreateJoint(joint1);
    this.movePlatform1BodyDirection = 1;

    const joint2 = new b2PrismaticJointDef();
    joint2.Initialize(this.dynamicBodies.movePlatform2, ground, this.dynamicBodies.movePlatform2.GetWorldCenter(), new b2Vec2(0, 1));
    joint2.enableLimit = false;
    joint2.enableMotor = false;
    this.world.CreateJoint(joint2);
    this.movePlatform2BodyDirection = 1;
  }

  updateLevelBodies() {
    const movePlatform1Y = this.dynamicBodies.movePlatform1.GetPosition().y * 30;
    if (movePlatform1Y < 270) {
      this.movePlatform1BodyDirection = 1;
    }
    if (movePlatform1Y > 425) {
      this.movePlatform1BodyDirection = -1;
    }
    this.dynamicBodies.movePlatform1.SetLinearVelocity(new b2Vec2(0, 3 * this.movePlatform1BodyDirection));

    const movePlatform2Y = this.dynamicBodies.movePlatform2.GetPosition().y * 30;
    if (movePlatform2Y < 116) {
      this.movePlatform2BodyDirection = 1;
    }
    if (movePlatform2Y > 271) {
      this.movePlatform2BodyDirection = -1;
    }
    this.dynamicBodies.movePlatform2.SetLinearVelocity(new b2Vec2(0, 3 * this.movePlatform2BodyDirection));
  }
}
